'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.animateScroll = undefined;
exports.updateHistory = updateHistory;

var _requestanimationframeTimer = require('requestanimationframe-timer');

var animateScroll = exports.animateScroll = function () {
  var timeoutId = void 0;
  var resolvePrevious = void 0;

  return function animateScroll(id, targetId, animate) {
    var targetElement = document.getElementById(targetId);

    function getScrollTop() {
      // like jQuery -> $('html, body').scrollTop
      return targetElement ? targetElement.scrollTop : document.documentElement.scrollTop || document.body.scrollTop;
    }

    function setScrollTop(position) {
      if (targetElement) {
        targetElement.scrollTop = position;
      } else {
        document.documentElement.scrollTop = document.body.scrollTop = position;
      }
    }

    return new Promise(function (resolve, reject) {
      var element = id ? document.getElementById(id) : document.body;

      if (!element) {
        return reject(new Error('Cannot find element: #' + id));
      }

      function getOffsetTop() {
        var parentOffsetTop = targetElement ? targetElement.getBoundingClientRect().top : 0;
        return element.getBoundingClientRect().top - parentOffsetTop + getScrollTop();
      }

      var offset = animate.offset,
          duration = animate.duration,
          easing = animate.easing;

      var start = getScrollTop();
      var to = getOffsetTop(element) + offset;
      var change = to - start;

      function animateFn() {
        var elapsedTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

        var increment = 20;
        var elapsed = elapsedTime + increment;
        var position = easing(null, elapsed, start, change, duration);
        setScrollTop(position);
        if (elapsed < duration) {
          timeoutId = (0, _requestanimationframeTimer.setTimeout)(function () {
            animateFn(elapsed);
          }, increment);
        } else {
          timeoutId = undefined;
          return resolve(id);
        }
      }

      if (timeoutId) {
        (0, _requestanimationframeTimer.clearTimeout)(timeoutId);
        resolvePrevious();
      }
      resolvePrevious = resolve;
      animateFn();
    });
  };
}();

function updateHistory(id) {
  id = '#' + id;
  if (history.pushState) {
    history.pushState(null, null, id);
  } else {
    location.hash = id;
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-scrollchor/lib/helpers.js
// module id = 264
// module chunks = 0